<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator />
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div v-loading="loading" class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <el-row>
              <el-col>
                <breadcrumbNavigationBar :data="breadcrumbNavigationBarData" />
              </el-col>
            </el-row>
            <el-row>
              <el-col>&nbsp;</el-col>
            </el-row>
            <div>
              <el-row type="flex" class="header-container">
                <el-col :span="16">&nbsp;</el-col>
                <el-col :span="8" class="action-container">
                  <el-button v-if="hasAddButton" type="primary" size="medium" :disabled="loading" @click="onAddClick">添加问题</el-button>
                </el-col>
              </el-row>
              <el-divider />
              <el-row class="grid-content">
                <el-col>
                  <pagination :data="tablePageData" :option="paginationOption" @search="search" @loadData="onLoadList" @pageSizeChange="pageSizeChange"
                    @currentPageChange="currentPageChange" @edit="onPaginationEdit" @delete="onPaginationDelete">
                    <template #QuestionType="{value}">{{GLOBAL.enumQuestionnaireQuestionType.getDesc(value)}}</template>
                    <template #ValueType="{value}">{{GLOBAL.enumQuestionnaireValueType.getDesc(value)}}</template>
                    <template #IsRequired="{value}">{{value ? "是" : "否"}}</template>
                    <template #IsMultiple="{value}">{{value != null ? (value ? "是" : "否") : ""}}</template>
                    <template #Enable="{value}">{{value ? "启用" : "停用"}}</template>
                  </pagination>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <questionnaireQuestionEditor key="questionnaireQuestionEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="isReadonly"
      :data="editorData" :questionnaireId="questionnaireId" :haveStudentRecords="haveStudentRecords" :maxIndex="maxIndex"
      :customValidator="handleEditorCustomValidator" @change="onEditorChange" />
  </div>
</template>

<script>
import { ObjectEx } from "vue-objectex";
import {
  checkHaveStudentRecords,
  getQuestionnaireQuestionPageData,
  deleteQuestionnaireQuestion,
} from "@/service/questionnaire.service";

const default_tablePageData = {
  AdditionalResult: {},
  Columns: [],
  CurrentPage: 1,
  PageCount: 0,
  PageSize: 20,
  RecordCount: 0,
  Results: [],
};

const mixin_bnBar = {
  components: {
    breadcrumbNavigationBar: () =>
      import("@/components/common/breadcrumbNavigationBar"),
  },
  data() {
    return {
      navName: "问题列表",
      breadcrumbNavigationBarData: new ObjectEx(
        [
          {
            key: "name",
            value: "问卷管理",
          },
          {
            key: "currentName",
            value: this.$route.meta.navName,
          },
          {
            key: "navList",
            value: [
              {
                link: "/questionnaire/questionnaireList",
                name: "问卷列表",
              },
            ],
          },
        ],
        {
          updateCurrentName(newValue) {
            this.currentName = newValue;
          },
          updateNavList(newNavList) {
            this.navList = newNavList;
          },
        }
      ),
    };
  },
  created() {
    this.$nextTick(() => {
      if (!!this.$route.meta.navName) {
        this.navName = this.$route.meta.navName;
        this.breadcrumbNavigationBarData.updateCurrentName(this.navName);
      }
      this.updateNavListByRoute();
    });
  },
  methods: {
    updateNavListByRoute() {
      let navList = [];
      try {
        navList = this.$cryptoJS.enc.Base64.decode(this.routeQuery.navList);
        navList = JSON.parse(navList);
      } catch (error) {}
      if (Object.typeOf(navList) !== "array") return;

      let bnbNavList = [];
      navList.forEach((nav) => {
        let name;
        switch (nav.path) {
          case "/questionnaire/questionnaireList":
            name = "问卷列表";
            break;
        }

        if (!!name) {
          if (bnbNavList.length === 0) this.$route.meta.menuActive = nav.path;
          bnbNavList.push({
            basePath: nav.path,
            link: nav.path,
            name,
            data: nav.data,
          });
        }
      });
      this.breadcrumbNavigationBarData.updateNavList(bnbNavList);
    },
  },
};

export default {
  name: "questionnaireQuestionList",
  mixins: [mixin_bnBar],
  components: {
    navigator: () => import("@/components/navigator"),
    pagination: () => import("@/components/common/pagination"),
    questionnaireQuestionEditor: () =>
      import("@/components/questionnaire/questionnaireQuestionEditor"),
  },
  data() {
    return {
      loading: false,
      routeQuery: {},
      questionnaireId: 0,
      haveStudentRecords: true,
      pageSize: 20,
      paginationOption: {},
      tablePageData: Object.clone(default_tablePageData),
      editorData: null,
    };
  },
  created() {
    this.routeQuery = this.$route.query;
    this.questionnaireId = `${this.routeQuery.questionnaireId}`.toNumber();

    this.paginationOption = {
      displayPagination: false,
      hasAddButton: false,
      hasEditButton: true,
      hasDeleteButton: true,
      hasDeleteButtonWithEdit: true,
      hasSearch: false,
      fixedAction: "right",
      buttonWidth: 80,
      fnRowEditButtonText: (index, row) =>
        !this.isReadonly && !this.haveStudentRecords ? "编辑" : "查看",
      fnRowDeleteVisible: (index, row) =>
        !this.isReadonly && !this.haveStudentRecords,
    };

    this.init();
  },
  computed: {
    isReadonly() {
      return this.haveStudentRecords;
    },
    hasAddButton() {
      if (this.isReadonly) return false;

      return !this.haveStudentRecords;
    },
    maxIndex() {
      let allIndexes = this.tablePageData.AdditionalResult["AllIndexes"];
      if (!allIndexes || allIndexes.length === 0) return 0;

      return allIndexes.length > 0 ? Math.max(...allIndexes) : 0;
    },
  },
  methods: {
    async checkHaveStudentRecordsFromServer() {
      this.loading = true;
      try {
        let questionnaireId = this.questionnaireId;
        let result = await checkHaveStudentRecords(questionnaireId);
        if (!!result && result.success) {
          this.haveStudentRecords = result.data;
        } else {
          this.haveStudentRecords = true;
          this.$message.error(result.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async loadQuestionnaireQuestionPageDataFromServer(pageCondtion) {
      this.loading = true;
      try {
        let result = await getQuestionnaireQuestionPageData(pageCondtion);
        if (!!result && result.success) {
          this.tablePageData = result.data;
        } else {
          this.tablePageData = Object.clone(default_tablePageData);

          this.$message.error(result.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async deleteQuestionnaireQuestionToServer(id) {
      this.loading = true;

      try {
        let result = await deleteQuestionnaireQuestion(id);
        if (!!result && result.success) {
          this.$message({
            message: "删除问卷问题成功",
            type: "success",
          });
          return true;
        } else {
          this.$message({
            message: result.message || "删除问卷问题失败",
            type: "error",
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }

      return false;
    },

    async init() {
      await this.search();
    },
    getSearchPageCondition(pageNumber) {
      if (!pageNumber) {
        pageNumber = 1;
      }

      let additionalFilter = {
        questionnaireId: this.questionnaireId,
      };

      let pageCondition = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        additionalFilter: additionalFilter,
      };

      return pageCondition;
    },
    async search(pageNumber) {
      await this.checkHaveStudentRecordsFromServer();

      let pageCondition = this.getSearchPageCondition(pageNumber);
      await this.loadQuestionnaireQuestionPageDataFromServer(pageCondition);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.tablePageData.CurrentPage = value;
    },
    openEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "questionnaireQuestionEditor"
      );
      if (!refEditor) return;

      refEditor.showDialog();
    },
    closeEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentVipCourseRecordEditor"
      );
      if (!refEditor) return;

      refEditor.closeDialog();
    },
    onAddClick() {
      this.editorData = null;
      this.openEditor();
    },
    onPaginationEdit(index, row) {
      this.editorData = row;
      this.openEditor();
    },
    onPaginationDelete(index, row) {
      this.$confirm("您确定要删除该问卷问题吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let result = await this.deleteQuestionnaireQuestionToServer(row.Id);
          if (result) {
            this.search();
          }
        })
        .catch(() => {});
    },
    handleEditorCustomValidator(value, fieldName, model) {
      let result = {};

      switch (fieldName) {
        case "Index": {
          let allIndexes = this.tablePageData.AdditionalResult["AllIndexes"];
          let indexUsed = allIndexes.contains(value);
          if (indexUsed && model.Id > 0) {
            let matchedItem = this.tablePageData.Results.find(
              (item) => item.Id === model.Id
            );
            indexUsed = matchedItem.Index !== value;
          }
          result[fieldName] = {
            success: !indexUsed,
            message: indexUsed ? "序号已被其他问卷问题使用" : null,
          };
          break;
        }
      }

      return result;
    },
    onEditorChange() {
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.header-container {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  vertical-align: bottom;

  .el-button {
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.cs-buttons {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/page/questionnaire/questionnaireQuestionList.vue